import React from 'react';
import VstComponent from './VstComponent';
import svgSortIcon from '../images/sort_icon.svg';

class VstTableHeader extends VstComponent {

  _capitalizeFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  render() {
    const children = React.Children.map(this.props.children, (child, index) => {
      if (child) {
        return (
          <th key={`header-cell-${index}`}>
            <button onClick={() => this.props.onClick(index)}>
              <span>{this._capitalizeFirst(child)} <span className="sortIcon" role="presentation">{svgSortIcon()}</span>
              </span>
            </button>
          </th>
        );
      }
      return (<th key={`header-cell-${index}`}><button><span></span></button></th>);
    });

    return (
      <thead>
        <tr>
          {children}
          <th className="vst-table-col-hidden" key={`header-cell- ${children.length}`}><div></div></th>
        </tr>
      </thead>
    );
  }
}

export default VstTableHeader;
